export const MOBILE_PANEL_BREAKPOINT = 640
export const PANEL_TRANSITION_MS = 300
export const TASK_CONTEXT_PARAM = "task"

export function panelPresentation(viewportWidth) {
  const modal = Number(viewportWidth) < MOBILE_PANEL_BREAKPOINT
  return {
    modal,
    lockScroll: modal
  }
}

export function panelHistoryAction(alreadyOpen) {
  return alreadyOpen ? "replaceState" : "pushState"
}

export function panelClosePlan(historyState) {
  return {
    hideImmediately: true,
    navigateBack: Boolean(historyState?.slidePanel && historyState?.slidePanelCloseMode !== "replace"),
    replaceUrl: historyState?.slidePanelCloseMode === "replace" ? historyState.slidePanelReturnUrl : null
  }
}

export function panelTranslation(open) {
  return open ? "0 0" : "100% 0"
}

export function taskIdFromRecordUrl(recordUrl, baseUrl) {
  try {
    const url = new URL(recordUrl, baseUrl)
    const match = url.pathname.match(/^\/tasks\/([^/]+)$/)
    return match ? decodeURIComponent(match[1]) : null
  } catch (_) {
    return null
  }
}

export function taskContextUrl(locationUrl, recordUrl) {
  try {
    const location = new URL(locationUrl)
    const taskId = taskIdFromRecordUrl(recordUrl, location)
    if (!taskId || !/^\/tasks(?:\/(?:board|calendar|gantt))?\/?$/.test(location.pathname)) return recordUrl

    location.searchParams.set(TASK_CONTEXT_PARAM, taskId)
    return location.toString()
  } catch (_) {
    return recordUrl
  }
}

export function taskContextRestoration(locationUrl) {
  try {
    const location = new URL(locationUrl)
    const taskId = location.searchParams.get(TASK_CONTEXT_PARAM)
    if (!taskId || !/^\/tasks(?:\/(?:board|calendar|gantt))?\/?$/.test(location.pathname)) return null

    const returnUrl = new URL(location)
    returnUrl.searchParams.delete(TASK_CONTEXT_PARAM)
    return {
      taskId,
      recordUrl: `${location.origin}/tasks/${encodeURIComponent(taskId)}`,
      returnUrl: returnUrl.toString()
    }
  } catch (_) {
    return null
  }
}
